module.exports = __webpack_public_path__ + "media/images/front/varieties/TANG-GOLD-87610431bf33a6c5b6820e955d046751.jpg";